module.exports = __webpack_public_path__ + "assets/118903b413a4190b30ce1bfb42312b7f.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/hu/video.webm
// module id = 346
// module chunks = 1